<template>
  <div>
    <v-row>
      <v-col cols="12">
        <VTextField
          :value="analysisType.formula"
          :label="$t('forms.labels.formula')"
          :disabled="true"
          outlined
        />
      </v-col>
    </v-row>
    <div>{{ $t('analyses.definitionOfVariables') }}</div>
    <div style="margin: 1%">
      <v-row style="background-color: #26384b; color: #fff;">
        <v-col>
          {{ $t('analyses.variables') }}
        </v-col>
        <v-col>
          {{ $t('forms.labels.analysisTypes') }}
        </v-col>
      </v-row>
      <v-row
        v-for="(variable, index) in analysisType.variablesName"
        :key="index"
        style="border: 1px solid #26384b"
      >
        <v-col>
          {{ variable.variableName }}
        </v-col>
        <v-col style="border-left: 1px solid #26384b">
          {{ variable.analysisType.name[userLang] || variable.analysisType.name[teamMainLang] }}
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import { mapGetters } from 'vuex';

export default {
    components: {
        VTextField,
    },
    props: {
        analysisType: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
        ]),
    },
};
</script>
